import React from 'react';
import { ShowButton, Datagrid, TextInput, TextField, DateField, Filter, SelectInput, DateInput } from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import TList from '../../components/wrapper/TList';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import { coreWalletInvoiceTypesForSelection, coreWalletInvoiceStatusForSelection } from './InvoiceConstants';

const InvoiceFilter = props => (
	<Filter {...props}>
		<TextInput source="walletAccountId" defaultValue="" />
		<TextInput source="invoiceOwnerId" defaultValue="" />
		<TextInput source="invoiceOwnerType" defaultValue="" />
		<TextInput source="invoiceCustomType" defaultValue="" />
		<TextInput source="systemAccountId" defaultValue="" />
		<SelectInput source="invoiceType" choices={coreWalletInvoiceTypesForSelection} />
		<SelectInput source="invoiceStatus" choices={coreWalletInvoiceStatusForSelection} />
		<DateInput
			source="fromDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<DateInput
			source="untilDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
	</Filter>
);

const InvoiceList = props => (
	<TList
		{...props}
		filters={<InvoiceFilter />}
		exporter={false}
		>
		<Datagrid>
			<ShowButton />
			<TextField source="id" sortable={false} />
			<DateField source="creationDateTime" showTime sortable={false} />
			<AmountField source="amount" sortable={false} />
			<TextField source="invoiceType" sortable={false} />
			<TextField source="invoiceStatus" sortable={false} />
			<TextField source="description" sortable={false} />
		</Datagrid>
	</TList>
);

export default InvoiceList;
